import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-section-progress-report',
 imports: [RouterModule],
  templateUrl: './section-progress-report.component.html',
  styleUrl: './section-progress-report.component.css'
})
export class SectionProgressReportComponent {

}
